/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_DescInputs */



/**
* | output |
* | --- |
* | "Add 608/708 closed caption track" |
*
* @param {File_Export_Embed_Captions_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_desc = /** @type {((inputs?: File_Export_Embed_Captions_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une piste de sous-titres 608/708")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge die Untertitelspur 608/708 hinzu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi traccia sottotitoli 608/708")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить дорожку субтитров 608/708")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar pista de subtítulos 608/708")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加 608/708 隐藏式字幕轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("608/708クローズドキャプショントラックを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("608/708 क्लोज्ड कैप्शन ट्रैक जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar faixa de legenda oculta 608/708")
	return /** @type {LocalizedString} */ ("Add 608/708 closed caption track")
});